import { render, staticRenderFns } from "./order-person-company.vue?vue&type=template&id=101648d8&"
import script from "./order-person-company.vue?vue&type=script&lang=js&"
export * from "./order-person-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports